module.exports = __webpack_public_path__ + "img/indian-rupee-sign.75cb2cc7.svg";